<template>
    <div>

        <div v-if="loading" class="text-center">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </div>
        <div v-else>
            <vue-headful :title="client.client_name + ' :: MeritEHS'"/>

            <h4 class="py-3 mb-4">
                <ol class="breadcrumb font-weight-bold m-0">
                    <li class="breadcrumb-item font-weight-light">
                        <router-link :to="`/jobsites#clients`">
                            <i class="fa fa-address-book-o"></i> Clients
                        </router-link>
                    </li>
                    <li class="breadcrumb-item active">
                        {{ client.client_name }}
                    </li>
                </ol>
            </h4>

            <div class="row">
                <div class="col-lg-9 col-md-12">

                </div>
                <div class="col-lg-3 col-md-12">

                </div>
            </div>

            <div class="row mb-4">
                <div class="col-xl-9 col-12">
                    <div class="card">
                        <h6 class="card-header">
                            <strong>Client details</strong>

                            <span class="pull-right">
                                <router-link :to="`/clients/edit/${client.client_id}`" class="btn btn-sm btn-light">
                                    <i class="fa fa-edit"></i> Edit
                                </router-link>
                            </span>
                        </h6>
                        <div class="card-body">
                            <div class="row">
                                <div class="col-md-6 col-12 mb-md-0 mb-2">
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted text-md-right">Client Name:</div>
                                        <div class="col-md-8">
                                            {{ client.client_name }}
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted text-md-right">Contact Name:</div>
                                        <div class="col-md-8">
                                            {{ client.contact_name }}
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted text-md-right">Phone:</div>
                                        <div class="col-md-8">
                                            {{ client.contact_phone }}
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted text-md-right">Email:</div>
                                        <div class="col-md-8">
                                            {{ client.contact_email }}
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6 col-12">
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted text-md-right">Created:</div>
                                        <div class="col-md-8">
                                            {{ client.created_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted text-md-right">Last Updated:</div>
                                        <div class="col-md-8">
                                            {{ client.updated_at | moment('timezone', userTimezone, "MM/DD/YYYY hh:mm a") }}
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted text-md-right">Client Address:</div>
                                        <div class="col-md-8">
                                            {{ client.client_address }}
                                        </div>
                                    </div>
                                    <div class="row mb-sm-2 mb-3">
                                        <div class="col-md-4 text-muted text-md-right">Notes:</div>
                                        <div class="col-md-8">
                                            {{ client.client_notes }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <ul class="search-nav nav nav-tabs tabs-alt container-p-x container-m--x mb-4 d-lg-flex d-none">
                <b-nav-item :active="curTab === 'jobsites'" @click="curTab = 'jobsites'">
                    <i class="fa fa-building"></i> Jobsites
                </b-nav-item>
                <b-nav-item :active="curTab === 'metric'" @click="curTab = 'metric'">
                    <i class="fa fa-pie-chart"></i> Approval Metrics <b-button size="xs" variant="primary" v-on:click="newMetric()" title="Create a New Client Safety Metric" v-if="canManage"><i class="fa fa-plus-circle"></i> New</b-button>
                </b-nav-item>
                <b-nav-item :active="curTab === 'approvals'" @click="curTab = 'approvals'" v-if="this.$root.hasPermission('subcontractors.view.approvals')">
                    <i class="fa fa-id-badge"></i> Subcontractor Approvals
                </b-nav-item>
            </ul>

            <div class="mb-2 mb-lg-0 d-lg-none d-block">
                <b-dropdown :html="tabButtonTitle" variant="default" class="bg-white">
                    <b-dropdown-item :active="curTab === 'jobsites'" @click="curTab = 'jobsites'">
                        <i class="fa fa-building"></i> Jobsites
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'metric'" @click="curTab = 'metric'">
                        <i class="fa fa-pie-chart"></i> Approval Metrics <b-button size="xs" variant="primary" v-on:click="newMetric()" title="Create a New Client Safety Metric" v-if="canManage"><i class="fa fa-plus-circle"></i> New</b-button>
                    </b-dropdown-item>
                    <b-dropdown-item :active="curTab === 'approvals'" @click="curTab = 'approvals'" v-if="this.$root.hasPermission('subcontractors.view.approvals')">
                        <i class="fa fa-id-badge"></i> Subcontractor Approvals
                    </b-dropdown-item>
                </b-dropdown>
            </div>

            <div class="mb-4">
                <div class="card" v-show="curTab === 'jobsites'">
                    <div class="card-body">
                        <jobsite-list assetType="Client" :assetId="client_id" />
                    </div>
                </div>

                <div class="card" v-show="curTab === 'metric'">
                    <div class="card-body">
                        <metric-modal ref="clientMetricModal" :clientId="client.client_id" @metricSaved="updateMetrics" />

                        <div v-for="metric in client.metrics">
                            <b-card class="metric-card mb-3">
                                <h4 slot="header" class="mb-0">
                                    <template v-if="canManage">
                                        <b-button size="sm" variant="secondary" title="Edit Metric" v-on:click="editMetric(metric)"><i class="fa fa-edit"></i> Edit</b-button>
                                        <b-button size="sm" variant="outline-danger" title="Delete Metric" v-on:click="deleteMetric(metric)"><i class="fa fa-trash"></i></b-button>
                                    </template>
                                    {{ metric.metric_name }}
                                </h4>

                                <div class="row">
                                    <div class="col-lg-4 col-md-6">
                                        <h6 class="mb-0">Conditions</h6>
                                        <small class="text-muted">Subcontractor Conditions Must be met first to attempt the rules below</small>
                                        <ul>
                                            <li v-for="condition in metric.conditions">
                                                {{ condition.attribute }} {{ condition.logic }} {{ condition.value }}
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="col-lg-4 col-md-6">
                                        <h6 class="mb-0">Rules</h6>
                                        <small class="text-success">Non-IFR Minimun Required: {{ metric.min_passing_rules }}</small>
                                        <ul>
                                            <li v-for="rule in metric.rules">
                                                {{ rule.attribute }} {{ rule.logic }} {{ rule.value }} <span v-if="rule.immediate_fail == true" class="badge badge-danger" title="Immediate Failure Rule. If this fails, the whole metric fails.">IFR</span>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </b-card>
                        </div>

                        <div v-if="client.metrics.length === 0">
                            -- No Approval Metrics for this Client. Client "New" to Add --
                        </div>
                    </div>
                </div>

                <div class="card" v-show="curTab === 'approvals'" v-if="this.$root.hasPermission('subcontractors.view.approvals')">
                    <div class="card-body">
                        <client-subcontractor-approvals assetType="Client" :assetId="client.client_id" :columns="columns"></client-subcontractor-approvals>
                    </div>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                curTab: 'jobsites',
                loading: true,
                client_id: this.$route.params.id,
                userTimezone: this.$store.state.user.timezone,
                client: {},
                columns: ['sub_approval_id', 'subcontractor_name', 'sub_status_name', 'approval_status_name', 'approval_created_at', 'sub_last_updated_at'],

                settingsTabs: {
                    jobsites: 'Jobsites',
                    metric: 'Approval Metrics',
                    approvals: 'Subcontractor Approvals',
                },
            }
        },

        computed: {
            canManage(){
                return this.$root.hasPermission('clients.manage');
            },

            tabButtonTitle(){
                //Setup
                var icon = '';

                //Switch
                switch(this.curTab)
                {
                    case 'jobsites':
                        //Set
                        icon = 'fa-building';
                        break;

                    case 'metric':
                        //Set
                        icon = 'fa-pie-chart';
                        break;

                    case 'approvals':
                        //Set
                        icon = 'fa-id-badge';
                        break;
                }

                //Send it
                return '<i class="fa '+icon+'"></i> ' + this.settingsTabs[this.curTab];
            },
        },

        methods: {


            newMetric(){
                //Set the {}}
                this.$refs.clientMetricModal.setModel();

                //Activate the modal
                this.$refs.clientMetricModal.showModal();
            },

            editMetric(metric){
                //Set the metric
                this.$refs.clientMetricModal.setModel(metric);

                //Activate the modal
                this.$refs.clientMetricModal.showModal();
            },

            deleteMetric(metric){
                //Confirm
                if(!confirm('Are you sure you want to delete this Metric? This cannot be undone'))
                {
                    return;
                }

                //Get the data
                this.$http
                    .post('clients/metric/delete/' + metric.client_metric_id)
                    .then(response => {
                        //Alert the user
                        this.$toastr.success('Metric Deleted');

                        //Remove from the list
                        this.updateMetrics(metric, true);
                    })
                    .catch(response => {

                    });

            },

            newSubcontractor(){
                //Set the {}}
                this.$refs.subcontractorApprovalModal.setModel();

                //Activate the modal
                this.$refs.subcontractorApprovalModal.showModal();
            },

            getClient() {
                //Get the data
                this.$http
                    .get('clients/view/' + this.client_id)
                    .then(response => {
                        //Set all the data
                        this.client = response.data;

                        //Set loading
                        this.loading = false;
                    })
                    .catch(response => {

                    });
            },

            updateMetrics(metric, deleteMode = false){
                //We need to check to see if the metric is new, or updated
                for (var i = this.client.metrics.length - 1; i >= 0; i--)
                {
                    //If the IDs match, replace it
                    if(this.client.metrics[i].client_metric_id == metric.client_metric_id)
                    {
                        //Splice and reset
                        if(deleteMode)
                        {
                            //SPlice only
                            this.client.metrics.splice(i, 1);
                        }
                        else
                        {
                            this.client.metrics.splice(i, 1, metric);
                        }

                        //Stop here;
                        return;
                    }
                }

                //If it get here, it's a new metric. Push it
                this.client.metrics.push(metric);
            },
        },

        mounted() {
            //Get the incidents
            this.getClient();
        }
    }
</script>

<style>
    .metric-card .card-header {
        background-color: #fafafa;
    }
</style>
